<template>
    <v-card>
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-img height="80" src="@/assets/images/fondo1.png">
            <v-row class="pa-4" align="center" justify="center">
                <v-col fluid>
                    <v-list-item-avatar color="yellow" size="40" class="ma-0">
                        <v-icon size="30">support_agent</v-icon>
                    </v-list-item-avatar>
                    <span class="headline black--text ma-4">CRM</span>
                </v-col>
            </v-row>
        </v-img>
        <v-dialog v-model="dPersonaModalDialog" persistent max-width="1100px">
            <v-card>
                <v-card-title style="background-color:#455A64">
                    <v-form ref="refCrmCliente">
                        <v-row fluid>
                            <v-col cols="9" xm="12" sm="9" md="9" class="pa-1">
                                <v-text-field @keyup.enter="fuCrmClienteSearch" v-model="dDNINombre" label="DNI o Nombre" outlined prepend-inner-icon="credit_card" clearable :rules="[v => !!v || 'El campo es requerido']" :maxlength="120" counter autocomplete="off"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-btn @click="fuCrmClienteSearch" :loading="dPersonaTable.loading" color="blue-grey" dark x-large>
                                    <v-icon large left>search</v-icon> Buscar por {{coCampoTipo}}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-title>
                <v-data-table
                    v-model="dPersonaTable.selected"
                    :headers="dPersonaTable.headers"
                    :items="dPersonas"
                    :loading="dPersonaTable.loading"
                    single-select
                    item-key="id"
                    show-select
                    class="elevation-1">
                    <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                    <template v-slot:[`item.tipo`]="{ item }">
                        <span>{{item.tipo}}</span>
                        <v-icon :color='item.id_cliente==""?"warning":"success"'>{{item.id_cliente==""?"info":"check_circle"}}</v-icon>
                    </template>
                </v-data-table>
                <v-card-actions class="blue-grey darken-2">
                    <v-btn @click="fuPersonaSelected()" color="green" dark><v-icon>check</v-icon> Seleccionar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="dPersonaModalDialog = false" color="grey darken-4" dark><v-icon>close</v-icon> Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col cols="3">
                <v-card>
                    <v-img src="@/assets/images/fondo1.png" height="150px">
                        <v-app-bar flat color="rgba(0, 0, 0, 0)">
                            <v-toolbar-title class="title white--text pl-0">{{dPersona.tipo}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn @click="dPersonaModalDialog = true" rounded x-small dark color="blue-grey">
                                <v-icon>search</v-icon> Buscar
                            </v-btn>
                        </v-app-bar>
                        <v-row justify="space-around">
                            <v-avatar size="80">
                                <img v-if="dPersona.Sexo=='F'" src="@/assets/images/user2.jpg" alt="Alumno">
                                <img v-else src="@/assets/images/user1.jpg" alt="Postulante">
                            </v-avatar>
                        </v-row>
                    </v-img>
                    <v-list two-line>
                        <v-list-item>
                            <v-list-item-icon><v-icon>person</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-subtitle>{{dPersona.Persona}}</v-list-item-subtitle><v-list-item-subtitle>Apellidos y Nombres</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon>bookmark</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{dPersona.Servicio}}</v-list-item-title><v-list-item-subtitle>Carrera</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon>credit_card</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{dPersona.DNI}}</v-list-item-title><v-list-item-subtitle>DNI</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon>phone</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{dPersona.Celular}} - {{dPersona.Telefono}}</v-list-item-title><v-list-item-subtitle>Celular - Telefono</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
            <v-col cols="9">
                <v-tabs v-model="dTab" dark>
                    <v-tab href='#tab-1'><v-icon left>receipt</v-icon>Ticket</v-tab>
                    <v-tab @click="fucrmllamadaByid_cliente" href='#tab-2'><v-icon left>perm_phone_msg</v-icon>Tareas</v-tab>
                    <v-tab @click="fucrmcompromisoByid_cliente" href='#tab-3'><v-icon left>front_hand</v-icon>Compromiso</v-tab>

                    <v-tab-item value='tab-1'>
                        <v-data-table :headers="dCrmTicketTable.headers" :items="dCrmTickets" :loading="dCrmTicketTable.loading" :search="dCrmTicketTable.search" class="elevation-1">
                            <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                            <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dCrmTicketTable.search }}".</v-alert></template>
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-spacer></v-spacer>
                                    <v-dialog v-model="dCrmTicketModal.dialog" max-width="1000">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-show="dPersona.id_cliente" color="primary" class="ma-4" v-bind="attrs" v-on="on"><v-icon>add</v-icon> Agregar</v-btn>
                                        </template>
                                        <template>
                                            <v-form ref="refCrmTicketModal">
                                                <v-card :loading="dCrmTicketModal.IsUpdating">
                                                    <v-toolbar class="blue justify-end">
                                                        <span class="headline">Ticket</span>
                                                        <v-spacer></v-spacer>
                                                        <v-btn @click="fuCrmTicketSave" color="primary" :loading="dCrmTicketModal.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                                                        <v-btn @click="dCrmTicketModal.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                                                    </v-toolbar>
                                                    <v-card-text fluid>
                                                        <v-row dense>
                                                            <v-col cols="12" xm="12" sm="12" md="8">
                                                                <v-autocomplete label="* Tipo" v-model="dCrmTicket.id_tipo"
                                                                    :items="dCrmTicketTipos" item-value="id" item-text="nombre" persistent-hint
                                                                    filled prepend-inner-icon="invert_colors" :disabled="dCrmTicketModal.IsUpdating" :rules="[v => !!v || 'El campo es requerido']">
                                                                </v-autocomplete>
                                                            </v-col>
                                                            <v-col cols="12" xm="12">
                                                                <v-textarea v-model="dCrmTicket.detalle" label="* Titulo Ticket"
                                                                    prepend-inner-icon="receipt" outlined rows="2" row-height="15" :rules="[v => !!v || 'El campo es requerido']"
                                                                ></v-textarea>
                                                            </v-col>
                                                            <v-col cols="12" xm="12">
                                                                <v-card color="blue lighten-3">
                                                                    <v-card-text>
                                                                        <v-col cols="12" xm="12" sm="12" md="8">
                                                                            <v-autocomplete label="* Asignar a:" v-model="dCrmTicket.id_asignado"
                                                                                :items="dPriPersonals" item-value="IdKhipuPlus" item-text="Personal"
                                                                                filled prepend-inner-icon="assignment_ind" :disabled="dCrmTicketModal.IsUpdating" :rules="[v => !!v || 'El campo es requerido']">
                                                                            </v-autocomplete>
                                                                        </v-col>
                                                                        <v-col cols="12" xm="12">
                                                                            <v-textarea v-model="dCrmTicketComentario_mensaje" label="* Mensaje"
                                                                                prepend-inner-icon="message" outlined rows="2" row-height="15" :rules="[v => !!v || 'El campo es requerido']"
                                                                            ></v-textarea>
                                                                        </v-col>
                                                                        <v-col cols="12" xm="12">
                                                                            <input style="display: none" type="file" @change="onFileSelected" ref="fileInput" accept="image/*" >
                                                                            <v-btn @click.prevent="$refs.fileInput.click()"><v-icon left>cloud_upload</v-icon> Subir Imagen</v-btn>
                                                                            <v-img max-height="139" max-width="250" :src="coImagen"></v-img>
                                                                        </v-col>
                                                                    </v-card-text>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-form>
                                        </template>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.id`]="{ item }">
                                <v-btn @click="$router.push(`/TicketItem/${item.id}`);" color="success" text>{{item.id}}</v-btn>
                            </template>
                            <template v-slot:[`item.crmcliente`]="{ item }">
                                <span v-if="item.crmcliente.prialumno">{{item.crmcliente.prialumno.Alumno}} - Codigo:{{item.crmcliente.prialumno.Codigo}} - DNI: {{item.crmcliente.prialumno.DNI}}</span>
                                <span v-else>{{item.crmcliente.admvisita.Visitante}} - DNI:{{item.crmcliente.admvisita.Dni}}</span>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item value='tab-2'>
                        <v-data-table :headers="dCrmLlamadaTable.headers" :items="dCrmLlamadas" :loading="dCrmLlamadaTable.loading" :search="dCrmLlamadaTable.search" class="elevation-1">
                            <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                            <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dCrmLlamadaTable.search }}".</v-alert></template>
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-spacer></v-spacer>
                                    <v-dialog v-model="dCrmLlamadaModal.dialog" max-width="1000">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-show="dPersona.id_cliente" color="primary" class="ma-4" v-bind="attrs" v-on="on"><v-icon>add</v-icon> Agregar</v-btn>
                                        </template>
                                        <template>
                                            <v-card>
                                                <v-toolbar class="blue justify-end">
                                                    <span class="headline">Tarea</span>
                                                    <v-spacer></v-spacer>
                                                    <v-btn @click="fuCrmLlamadaSave" color="primary" :loading="dCrmLlamadaModal.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                                                    <v-btn @click="dCrmLlamadaModal.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                                                </v-toolbar>
                                                <v-card-text>
                                                    <v-form ref="refCrmLlamadaModal">
                                                        <v-row dense>
                                                            <v-col cols="12" sm="12" md="12">
                                                                <v-autocomplete v-model="dCrmLlamada.id_campania" label="Campaña Relacionada"
                                                                    :items=dCrmCampanias item-value="id" item-text="nombre"
                                                                    outlined prepend-inner-icon="campaign" :disabled="dCrmLlamadaModal.IsUpdating" :rules="[v => !!v || 'El campo es requerido']">
                                                                </v-autocomplete>
                                                            </v-col>
                                                            <v-col cols="12" sm="12" md="12">
                                                                <v-autocomplete v-model="dCrmLlamada.id_tipo_llamada" label="Tipo de Tarea"
                                                                    :items=dCrmTipoLlamadas item-value="id" item-text="descripcion"
                                                                    outlined prepend-inner-icon="invert_colors" :disabled="dCrmLlamadaModal.IsUpdating" :rules="[v => !!v || 'El campo es requerido']">
                                                                </v-autocomplete>
                                                            </v-col>
                                                            <v-col cols="12" sm="12" md="12">
                                                                <v-textarea v-model="dCrmLlamada.descripcion"
                                                                    prepend-inner-icon="article"
                                                                    label="Descripción"
                                                                    outlined
                                                                    rows="2"
                                                                    row-height="15" :rules="[v => !!v || 'El campo es requerido']"
                                                                ></v-textarea>
                                                            </v-col>
                                                            <v-col cols="12" sm="12" md="12">
                                                                <v-text-field v-model="dCrmLlamada.resultado" label="Resultado de la llamada" prepend-inner-icon="perm_phone_msg" outlined dense :rules="[v => !!v || 'El campo es requerido']" :maxlength="40" autocomplete="off"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" xm="12" sm="6">
                                                                <div class="subtitle-1">Fecha Llamada</div>
                                                                <v-date-picker v-model="dCrmLlamadaFecha.date" landscape></v-date-picker>
                                                            </v-col>
                                                            <v-col cols="12" xm="12" sm="6">
                                                                <div class="subtitle-1">Hora Llamada</div>
                                                                <v-time-picker v-model="dCrmLlamadaFecha.time" format="24hr" landscape></v-time-picker>
                                                            </v-col>
                                                        </v-row>
                                                    </v-form>
                                                </v-card-text>
                                            </v-card>
                                        </template>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item value='tab-3'>
                        <v-data-table :headers="dCrmCompromisoTable.headers" :items="dCrmCompromisos" :loading="dCrmCompromisoTable.loading" :search="dCrmCompromisoTable.search" class="elevation-1">
                            <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                            <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dCrmCompromisoTable.search }}".</v-alert></template>
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-spacer></v-spacer>
                                    <v-dialog v-model="dCrmCompromisoModal.dialog" max-width="1000">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-show="dPersona.id_cliente" color="primary" class="ma-4" v-bind="attrs" v-on="on"><v-icon>add</v-icon> Agregar</v-btn>
                                        </template>
                                        <template>
                                            <v-card>
                                                <v-toolbar class="blue justify-end">
                                                    <span class="headline">Compromiso</span>
                                                    <v-spacer></v-spacer>
                                                    <v-btn @click="fuCrmCompromisoSave" color="primary" :loading="dCrmCompromisoModal.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                                                    <v-btn @click="dCrmCompromisoModal.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                                                </v-toolbar>
                                                <v-card-text>
                                                    <v-form ref="refCrmCompromisoModal">
                                                        <v-row dense>
                                                            <v-col cols="12" sm="12" md="12">
                                                                <v-autocomplete v-model="dCrmCompromiso.id_campania" label="* Campaña Relacionada"
                                                                    :items=dCrmCampanias item-value="id" item-text="nombre"
                                                                    outlined prepend-inner-icon="campaign" :disabled="dCrmCompromisoModal.IsUpdating" :rules="[v => !!v || 'El campo es requerido']">
                                                                </v-autocomplete>
                                                            </v-col>
                                                            <v-col cols="12" sm="12" md="12">
                                                                <v-autocomplete v-model="dCrmCompromiso.id_compromiso_tipo" label="* Tipo"
                                                                    :items=dCrmCompromisoTipos item-value="id" item-text="nombre"
                                                                    outlined prepend-inner-icon="label" :disabled="dCrmCompromisoModal.IsUpdating" :rules="[v => !!v || 'El campo es requerido']">
                                                                </v-autocomplete>
                                                            </v-col>
                                                            <v-col cols="12" sm="12" md="12">
                                                                <v-textarea v-model="dCrmCompromiso.Observacion"
                                                                    label="* Descripción" prepend-inner-icon="article" outlined rows="2"
                                                                    row-height="15" :rules="[v => !!v || 'El campo es requerido']"
                                                                ></v-textarea>
                                                            </v-col>
                                                            <v-col cols="12" xm="12" sm="6">
                                                                <div class="subtitle-1">Fecha Vencimiento</div>
                                                                <v-date-picker v-model="dCrmCompromisoFecha.date" landscape></v-date-picker>
                                                            </v-col>
                                                            <v-col cols="12" xm="12" sm="6">
                                                                <div class="subtitle-1">Hora Vencimiento</div>
                                                                <v-time-picker v-model="dCrmCompromisoFecha.time" format="24hr" landscape></v-time-picker>
                                                            </v-col>
                                                            <v-col cols="12" xm="12" sm="6">
                                                                <v-select v-model="dCrmCompromiso.estado" label="Estado" :items="[{text: 'PENDIENTE', value: 0},{text: 'CUMPLIDO', value: 1},{text: 'NO CUMPLIDO', value: 2}]" filled></v-select>
                                                            </v-col>
                                                        </v-row>
                                                    </v-form>
                                                </v-card-text>
                                            </v-card>
                                        </template>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.estado`]="{ item }">
                                <v-btn v-if="item.estado==0" @click="fuCalendarAdd(item)" color="primary" icon><v-icon>event_available</v-icon></v-btn>
                                <v-icon v-if="item.estado==0" color="warning" title="PENDIENTE">watch_later</v-icon>
                                <v-icon v-else-if="item.estado==1" color="success" title="CUMPLIDO">thumb_up</v-icon>
                                <v-icon v-else-if="item.estado==2" color="error" title="NO CUMPLIDO">thumb_down_alt</v-icon>
                                <v-menu bottom offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item v-if="item.estado!=0">
                                            <v-list-item-title><v-btn @click="fuCrmCompromisoEstadoUpdate(item, 0)" color="warning" block><v-icon left>watch_later</v-icon> Cambiar a PENDIENTE</v-btn></v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-if="item.estado!=1">
                                            <v-list-item-title><v-btn @click="fuCrmCompromisoEstadoUpdate(item, 1)" color="success" block><v-icon left>thumb_up</v-icon> Cambiar a  CUMPLIDO</v-btn></v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-if="item.estado!=2">
                                            <v-list-item-title><v-btn @click="fuCrmCompromisoEstadoUpdate(item, 2)" color="error" block dark><v-icon left>thumb_down_alt</v-icon> Cambiar a  NO CUMPLIDO</v-btn></v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs>
            </v-col>
        </v-row>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-card>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
    name: 'Crm',
    mounted(){
    	this.fuLoad();
    },
    data: () => ({
        dCrmCampanias: [],
        dCrmCompromisos: [],
        dCrmCompromisoFecha: {
            date: moment().format("YYYY-MM-DD"),
            time: moment().format("HH:mm"),
        },
        dCrmCompromiso: {
            id_cliente: null,
            id_compromiso_tipo: null,
            id_campania: null,
            Observacion: '',
            id_operador: null,
            estado: 0,
            vencimiento_at: ''
        },
        dCrmCompromisoDefault: {
            id_cliente: null,
            id_compromiso_tipo: null,
            id_campania: null,
            Observacion: '',
            id_operador: null,
            estado: 0,
            vencimiento_at: ''
        },
        dCrmCompromisoModal: {
            dialog: false,
            IsUpdating: false,
        },
        dCrmCompromisoTable: {
            headers: [
                {value: 'estado', text: 'Estado'},
                {value: 'id', text: 'Nro', align: ' d-none'},
                {value: 'crmcompromisotipo.nombre', text: 'Tipo'},
                {value: 'Observacion', text: 'Observacion'},
                {value: 'created_at', text: 'F. Creacion'},
                {value: 'vencimiento_at', text: 'F. Vencimiento'},
                {value: 'pripersonal.Usuario', text: 'Creado por'},
            ],
            loading: false,
            search: null,
        },
        dCrmCompromisoTipos: [],
        dCrmLlamadas: [],
        dCrmLlamadaFecha: {
            date: moment().format("YYYY-MM-DD"),
            time: moment().format("HH:mm"),
        },
        dCrmLlamada: {
            id_cliente: null,
            id_campania: null,
            resultado: '',
            descripcion: '',
            id_operador: null,
            llamada_at: '',
            id_tipo_llamada: '1'
        },
        dCrmLlamadaDefault: {
            id_cliente: null,
            id_campania: null,
            resultado: '',
            descripcion: '',
            id_operador: null,
            llamada_at: '',
            id_tipo_llamada: '1'
        },
        dCrmLlamadaModal: {
            dialog: false,
            IsUpdating: false,
        },
        dCrmLlamadaTable: {
            headers: [
                {value: 'id', text: 'Nro', align: ' d-none'},
                {value: 'descripcion', text: 'Descripción'},
                {value: 'resultado', text: 'Resultado'},
                {value: 'crmtipollamada.descripcion', text: 'Tipo'},
                {value: 'llamada_at', text: 'F. Llamada'},
                {value: 'pripersonal.Usuario', text: 'Creado por'}
            ],
            loading: false,
            search: null,
        },
        dCrmTicket: {
            id_operador: '',
            id_asignado: '',
            detalle: '',
            id_estado: 1,
            id_tipo: '',
        },
        dCrmTicketDefault: {
            id_operador: '',
            id_asignado: '',
            detalle: '',
            id_estado: 1,
            id_tipo: '',
        },
        dCrmTickets: [],
        dCrmTicketComentario_mensaje: '',
        dCrmTicketModal: {
            dialog: false,
            IsUpdating: false,
        },
        dCrmTicketTable: {
            headers: [
                {value: 'id', text: 'Nro'},
                {value: 'created_at', text: 'F. Creacion'},
                {value: 'crmtickettipo.nombre', text: 'Tipo'},
                {value: 'crmticketestado.nombre', text: 'Estado'},
                {value: 'detalle', text: 'Titulo'},
                {value: 'pripersonal.Usuario', text: 'Creado por'},
                {value: 'pripersonal_asignado.Usuario', text: 'Derivado a'},
            ],
            loading: false,
            search: null,
        },
        dCrmTicketTipos: [],
        dCrmTipoLlamadas: [],
        dDNINombre: '',
        dImagenMiniatura: '',
        dLoading: false,
        dPersona: {
            id: '',
            DNI: '',
            Persona: '',
            Sexo: '',
            Telefono: '',
            Codigo: '',
            Celular: '',
            Servicio: '',
            tipo: '',
            id_cliente: '',
            id_zendesk: '',
        },
        dPersonaModalDialog: false,
        dPersonas: [],
        dPersonaTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'id', text: 'id'},
                {value: 'Persona', text: 'Persona'},
                {value: 'DNI', text: 'DNI', align: 'center', sortable: false},
                {value: 'Codigo', text: 'Codigo'},
                {value: 'Servicio', text: 'Carrera', align: 'center', sortable: false},
                {value: 'Celular', text: 'Celular', align: 'center', sortable: false},
                {value: 'Telefono', text: 'Telefono', align: 'center', sortable: false},
                {value: 'Sexo', text: 'Sexo', align: ' d-none'},
                {value: 'tipo', text: 'tipo'},
                {value: 'operador', text: 'Operador'}
            ],
            loading: false,
            selected: []
        },
        dPriPersonals: [],
        dSelectedFile: null,
        dSnackbar: false,
        dTab:0,
    }),
    computed: {
        ...mapState(['ssUser']),
        coCampoTipo: function () {
            if(this.dDNINombre==''){
                return '';
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    return 'DNI';
                else{
                    return 'Nombre';
                }
            }
        },
        coImagen(){
            return this.dImagenMiniatura;
        }
    },
    methods: {
        async fuLoad(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query {
                        crmcampaniaByEstado(Estado:1){
                            id
                            nombre
                        }
                        crmcompromisotipos{
                            id
                            nombre
                        }
                        crmtickettipos{
                            id
                            nombre
                        }
                        pripersonalKhipuPlus{
                            IdKhipuPlus
                            Personal
                            Usuario
                        }
                        crmtipollamadaByestado(estado:1){
                            id
                            descripcion
                        }
                    }`
                })
                this.dCrmCampanias = response.data.crmcampaniaByEstado;
                this.dCrmCompromisoTipos = response.data.crmcompromisotipos;
                this.dCrmTicketTipos = response.data.crmtickettipos;
                this.dPriPersonals = response.data.pripersonalKhipuPlus;
                this.dCrmTipoLlamadas = response.data.crmtipollamadaByestado;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
            }
        },
        fuCrmClienteSearch(){
            if(this.dDNINombre==''){
                this.dSnackbar = true;
            } else {
                this.dPersonas = [];
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    this.fucrmclienteSearchDNI(this.dDNINombre);
                else
                    this.fucrmclienteSearchNombre(this.dDNINombre)
            }
        },
        async fucrmclienteSearchDNI(pDni) {
            this.dPersonaTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query ($DNI: String!){
                        prialumnoByDNI(DNI: $DNI){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Sexo
                            Celular
                            Telefono
                            operador
                            priservicio{
                                Iniciales
                            }
                            crmcliente{
                                id
                                id_zendesk
                                id_tipo
                            }
                        },
                        admvisitaByDni(Dni: $DNI){
                            idVisitas
                            Visitante
                            Dni
                            vSexo
                            Celular
                            Telefono
                            Operador
                            priservicio{
                                Iniciales
                            }
                            crmcliente{
                                id
                                id_zendesk
                                id_tipo
                            }
                        }
                    }`,
                    variables: {
                        DNI: pDni
                    }
                })
                if(response.data){
                    this.dPersonas = response.data.prialumnoByDNI.map(item => {
                        if(item.crmcliente.id_tipo==1){
                            let vItem = {
                                id : item.IdAlumno,
                                Persona : item.Alumno,
                                DNI : item.DNI,
                                Codigo : item.Codigo,
                                Sexo : item.Sexo,
                                Celular : item.Celular,
                                Telefono : item.Telefono,
                                Servicio : item.priservicio.Iniciales,
                                id_cliente : "",
                                id_zendesk : "",
                                tipo : "ALUMNO",
                                operador : item.operador
                            };
                            if(item.crmcliente){
                                vItem.id_cliente = item.crmcliente.id;
                                vItem.id_zendesk = item.crmcliente.id_zendesk;
                            }
                            return vItem;
                        }
                    });
                    response.data.admvisitaByDni.map(item => {
                        let vcrmcliente = item.crmcliente
                        vcrmcliente.map(item2 =>{
                            if(item2.id_tipo==2){
                                let vItem = {
                                    id : item.idVisitas,
                                    Persona : item.Visitante,
                                    DNI : item.Dni,
                                    Codigo : "",
                                    Sexo : item.vSexo,
                                    Celular : item.Celular,
                                    Telefono : item.Telefono,
                                    Servicio : item.priservicio.Iniciales,
                                    id_cliente : "",
                                    id_zendesk : "",
                                    tipo : "VISITANTE",
                                    operador : item.Operador
                                };
                                if(item2){
                                    vItem.id_cliente = item2.id;
                                    vItem.id_zendesk = item2.id_zendesk;
                                }
                                this.dPersonas.push(vItem);
                                return true;
                            }
                        })
                        return true;
                    });

                }
            } catch (error) {
                console.log(error);
            } finally {
                this.dPersonaTable.loading = false;
            }
        },
        async fucrmclienteSearchNombre(pAlumno) {
            this.dPersonaTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query ($Nombre: String!){
                        prialumnoByAlumno(Alumno: $Nombre){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Sexo
                            Celular
                            Telefono
                            operador
                            priservicio{
                                Iniciales
                            }
                            crmcliente{
                                id
                                id_zendesk
                                id_tipo
                            }
                        },
                        admvisitasByVisitante(Visitante: $Nombre) {
                            idVisitas
                            Visitante
                            Dni
                            vSexo
                            Celular
                            Telefono
                            Operador
                            priservicio {
                                Iniciales
                            }
                            crmcliente {
                                id
                                id_zendesk
                                id_tipo
                            }
                        }
                    }`,
                    variables: {
                        Nombre: pAlumno
                    }
                })
                if(response.data){
                    response.data.prialumnoByAlumno.map(item => {
                        if(item.crmcliente){
                            if(item.crmcliente.id_tipo==1){
                                let vItem = {
                                    id : item.IdAlumno,
                                    Persona : item.Alumno,
                                    DNI : item.DNI,
                                    Codigo : item.Codigo,
                                    Sexo : item.Sexo,
                                    Celular : item.Celular,
                                    Telefono : item.Telefono,
                                    Servicio : item.priservicio.Iniciales,
                                    id_cliente : "",
                                    id_zendesk : "",
                                    tipo : "ALUMNO",
                                    operador : item.operador
                                };
                                
                                vItem.id_cliente = item.crmcliente.id;
                                vItem.id_zendesk = item.crmcliente.id_zendesk;
                                
                                this.dPersonas.push(vItem);
                                return true;
                            }
                        }
                        return true;
                    });
                    response.data.admvisitasByVisitante.map(item => {
                        let vcrmcliente = item.crmcliente
                        vcrmcliente.map(item2 =>{
                            if(item2.id_tipo==2){
                                let vItem = {
                                    id : item.idVisitas,
                                    Persona : item.Visitante,
                                    DNI : item.Dni,
                                    Codigo : "",
                                    Sexo : item.vSexo,
                                    Celular : item.Celular,
                                    Telefono : item.Telefono,
                                    Servicio : item.priservicio.Iniciales,
                                    id_cliente : "",
                                    id_zendesk : "",
                                    tipo : "VISITANTE",
                                    operador : item.Operador
                                };
                                if(item2){
                                    vItem.id_cliente = item2.id;
                                    vItem.id_zendesk = item2.id_zendesk;
                                }
                                this.dPersonas.push(vItem);
                                return true;
                            }
                        })
                        return true;
                    });
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.dPersonaTable.loading = false;
            }
        },
        fuPersonaSelected(){
            if(!this.dPersonaTable.selected){
                Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
            } else {
                if(this.dPersonaTable.selected.length==0)
                    Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
                else{
                    this.dPersona = {
                        id: this.dPersonaTable.selected[0].id,
                        DNI: this.dPersonaTable.selected[0].DNI,
                        Persona: this.dPersonaTable.selected[0].Persona,
                        Sexo: this.dPersonaTable.selected[0].Sexo,
                        Telefono: this.dPersonaTable.selected[0].Telefono,
                        Codigo: this.dPersonaTable.selected[0].Codigo,
                        Celular: this.dPersonaTable.selected[0].Celular,
                        Servicio: this.dPersonaTable.selected[0].Servicio,
                        tipo: this.dPersonaTable.selected[0].tipo,
                        id_cliente: this.dPersonaTable.selected[0].id_cliente,
                        id_zendesk: this.dPersonaTable.selected[0].id_zendesk,
                    };

                    this.dPersonaModalDialog = false;
                    this.dPersonas = this.dPersonaTable.selected = this.dCrmTickets = this.dCrmLlamadas = this.dCrmCompromisos = [];
                    this.dTab='tab-1';

                    if(this.dPersona.id_cliente!="")
                        this.fuCrmTicketSearch(this.dPersona.id_cliente);
                    else{
                        if(this.dPersona.tipo=="ALUMNO")
                            this.fucrmclienteCreateIdAlumno(this.dPersona.id);
                        else
                            this.fucrmclienteCreateIdVisitas(this.dPersona.id);
                    }
                }
            }
        },
        async fucrmclienteCreateIdVisitas(pidVisitas){
            this.dLoading = true;
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation crmclienteCreateIdVisitas($idVisitas: ID!){
                        crmclienteCreateIdVisitas(idVisitas: $idVisitas){
                            id
                        }
                    }`,
                    variables: {
                        idVisitas: pidVisitas
                    }
                });
                if(response.data){
                    this.dPersona.id_cliente = response.data.crmclienteCreateIdVisitas.id;
                    this.fuCrmTicketSearch(response.data.crmclienteCreateIdVisitas.id);
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
                this.fuReset();
            } finally {
                this.dLoading = false
            }
        },
        async fucrmclienteCreateIdAlumno(pIdAlumno){
            this.dLoading = true;
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation crmclienteCreateIdAlumno($IdAlumno: ID!){
                        crmclienteCreateIdAlumno(IdAlumno: $IdAlumno){
                            id
                        }
                    }`,
                    variables: {
                        IdAlumno: pIdAlumno
                    }
                });
                if(response.data){
                    this.dPersona.id_cliente = response.data.crmclienteCreateIdAlumno.id;
                    this.fuCrmTicketSearch(response.data.crmclienteCreateIdAlumno.id);
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
                this.fuReset();
            } finally {
                this.dLoading = false
            }
        },
        fuReset(){
            this.dPersonas = this.dPersonaTable.selected = this.dCrmTickets = this.dCrmLlamadas = this.dCrmCompromisos = [];
            this.dPersona = {
                id: '',
                DNI: '',
                Persona: '',
                Sexo: '',
                Telefono: '',
                Codigo: '',
                Celular: '',
                Servicio: '',
                tipo: '',
                id_cliente: '',
                id_zendesk: '',
            }

        },
        async fuCrmTicketSearch(pid_cliente){
            this.dCrmTicketTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query crmticketByid_cliente($id_cliente: Int!){
                        crmticketByid_cliente(id_cliente:$id_cliente){
                            id
                            detalle
                            created_at
                            updated_at
                            crmtickettipo{
                                nombre
                            }
                            crmticketestado{
                                nombre
                            }
                            pripersonal{
                                Usuario
                            }
                            pripersonal_asignado{
                                Usuario
                            }
                        }
                    }`,
                    variables: {
                        id_cliente: pid_cliente
                    }
                })
                this.dCrmTickets = this.dCrmLlamadas = this.dCrmCompromisos = [];
                this.dCrmTickets = response.data.crmticketByid_cliente;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dCrmTicketTable.loading = false
            }
        },
        async fucrmllamadaByid_cliente(){
            if(this.dPersona.id_cliente && this.dCrmLlamadas.length==0){
                this.dCrmLlamadaTable.loading = true;
                try {
                    const response = await this.$apollo.query({
                        query: gql`query crmllamadaByid_cliente($id_cliente: Int!){
                            crmllamadaByid_cliente(id_cliente:$id_cliente){
                                id
                                resultado
                                descripcion
                                llamada_at
                                pripersonal{
                                    Usuario
                                }
                                crmtipollamada{
                                    descripcion
                                }
                            }
                        }`,
                        variables: {
                            id_cliente: this.dPersona.id_cliente
                        }
                    })
                    this.dCrmLlamadas = [];
                    this.dCrmLlamadas = response.data.crmllamadaByid_cliente;
                } catch (error) {
                    console.log(error);
                    Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
                } finally {
                    this.dCrmLlamadaTable.loading = false
                }
            }            
        },
        async fucrmcompromisoByid_cliente(){
            if(this.dPersona.id_cliente && this.dCrmCompromisos.length==0){
                this.dCrmCompromisoTable.loading = true;
                try {
                    const response = await this.$apollo.query({
                        query: gql`query crmcompromisoByid_cliente($id_cliente: Int!){
                            crmcompromisoByid_cliente(id_cliente:$id_cliente){
                                id
                                Observacion
                                created_at
                                vencimiento_at
                                estado
                                pripersonal{
                                    Usuario
                                }
                                crmcompromisotipo{
                                    nombre
                                }
                            }
                        }`,
                        variables: {
                            id_cliente: this.dPersona.id_cliente
                        }
                    })
                    this.dCrmCompromisos = [];
                    this.dCrmCompromisos = response.data.crmcompromisoByid_cliente;
                } catch (error) {
                    console.log(error);
                    Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
                } finally {
                    this.dCrmCompromisoTable.loading = false
                }
            }            
        },
        fuCrmTicketSave(){
            if(!this.$refs.refCrmTicketModal.validate()){
                this.dSnackbar = true;
            } else {
                this.fuCrmTicketCreate();
            }
        },
        fuCrmLlamadaSave(){
            if(!this.$refs.refCrmLlamadaModal.validate()){
                this.dSnackbar = true;
            } else {
                this.fuCrmLlamadaCreate();
            }
        },
        fuCrmCompromisoSave(){
            if(!this.$refs.refCrmCompromisoModal.validate()){
                this.dSnackbar = true;
            } else {
                this.fuCrmCompromisoCreate();
            }
        },
        async fuCrmTicketCreate () {
            try {
                this.dCrmTicketModal.IsUpdating = true;
                this.dCrmTicket.id_operador = this.ssUser.IdKhipuPlus;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation crmticketCreateIdAlumno($IdAlumno: ID!, $mensaje: String, $file: Upload, $input: crmticketCreateInput!){
                        crmticketCreateIdAlumno(IdAlumno:$IdAlumno, mensaje: $mensaje, file: $file, input: $input){
                            id
                            created_at
                            updated_at
                        }
                    }`,
                    variables: {
                        IdAlumno: this.dPersona.id,
                        mensaje: this.dCrmTicketComentario_mensaje,
                        file: this.dSelectedFile,
                        input: this.dCrmTicket
                    },
                    context: {
                        hasUpload: true
                    }
                });
                if(response.data){
                    let vCrmTicket = {
                        id: response.data.crmticketCreateIdAlumno.id,
                        detalle: this.dCrmTicket.detalle,
                        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
                        updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
                        crmtickettipo: {
                            nombre: this.dCrmTicketTipos.find(obj => obj.id == this.dCrmTicket.id_tipo).nombre
                        },
                        crmticketestado: {
                            nombre: 'Nuevo'
                        },
                        pripersonal: {
                            Usuario: this.ssUser.Usuario
                        },
                        pripersonal_asignado: {
                            Usuario: this.dPriPersonals.find(obj => obj.IdKhipuPlus == this.dCrmTicket.id_asignado).Usuario
                        }
                    };
                    this.dCrmTickets.push(vCrmTicket);
                    Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                    this.fuCrmTicketModalClose();
                } else {
                    Swal.fire('¡ ERROR !', 'No se guardó.', 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dCrmTicketModal.IsUpdating = false;
            }
        },
        async fuCrmLlamadaCreate () {
            try {
                this.dCrmLlamadaModal.IsUpdating = true;
                this.dCrmLlamada.id_cliente = this.dPersona.id_cliente;
                this.dCrmLlamada.llamada_at = this.dCrmLlamadaFecha.date.replace(/-/g,'') +' '+this.dCrmLlamadaFecha.time;
                this.dCrmLlamada.id_operador = this.ssUser.IdKhipuPlus;
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation crmllamadaCreate($input: crmllamadaCreateInput!){
                        crmllamadaCreate(input: $input){
                            id
                        }
                    }`,
                    variables: {
                        input: this.dCrmLlamada
                    }
                });
                if(response.data){
                    let vCrmLlamada = {
                        id: response.data.crmllamadaCreate.id,
                        resultado: this.dCrmLlamada.resultado,
                        descripcion: this.dCrmLlamada.descripcion,
                        llamada_at: this.dCrmLlamada.llamada_at,
                        pripersonal: {
                            Usuario: this.ssUser.Usuario
                        }
                    };
                    this.dCrmLlamadas.push(vCrmLlamada);

                    Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                    this.fuCrmLlamadaModalClose();
                } else {
                    Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dCrmLlamadaModal.IsUpdating = false;
            }
        },
        async fuCrmCompromisoCreate () {
            try {
                this.dCrmCompromisoModal.IsUpdating = true;
                this.dCrmCompromiso.id_cliente = this.dPersona.id_cliente;
                this.dCrmCompromiso.vencimiento_at = this.dCrmCompromisoFecha.date.replace(/-/g,'') +' '+this.dCrmCompromisoFecha.time;
                this.dCrmCompromiso.id_operador = this.ssUser.IdKhipuPlus;
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation crmcompromisoCreate($input: crmcompromisoCreateInput!){
                        crmcompromisoCreate(input: $input){
                            id
                            vencimiento_at
                            created_at
                        }
                    }`,
                    variables: {
                        input: this.dCrmCompromiso
                    }
                });
                if(response.data){
                    let vCrmCompromiso = {
                        id: response.data.crmcompromisoCreate.id,
                        crmcompromisotipo: {
                            nombre: this.dCrmCompromisoTipos.find(obj => obj.id == this.dCrmCompromiso.id_compromiso_tipo).nombre
                        },
                        Observacion: this.dCrmCompromiso.Observacion,
                        created_at: response.data.crmcompromisoCreate.created_at,
                        vencimiento_at: response.data.crmcompromisoCreate.vencimiento_at,
                        estado: this.dCrmCompromiso.estado,
                        pripersonal: {
                            Usuario: this.ssUser.Usuario
                        }
                    };
                    this.dCrmCompromisos.push(vCrmCompromiso);

                    Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                    this.fuCrmCompromisoModalClose();
                } else {
                    Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dCrmCompromisoModal.IsUpdating = false;
            }
        },
        fuCrmTicketModalClose(){
            this.dCrmTicketModal.dialog = false;
            this.dCrmTicket = Object.assign({}, this.dCrmTicketDefault);
        },
        fuCrmCompromisoModalClose(){
            this.dCrmCompromisoModal.dialog = false;
            this.dCrmCompromiso = Object.assign({}, this.dCrmCompromisoDefault);
        },
        fuCrmLlamadaModalClose(){
            this.dCrmLlamadaModal.dialog = false;
            this.dCrmLlamada = Object.assign({}, this.dCrmLlamadaDefault);
        },
        async fuCrmCompromisoEstadoUpdate(vItem, vEstado){
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation crmcompromisoUpdate($id: ID!, $input: crmcompromisoUpdateInput!){
                        crmcompromisoUpdate(id: $id, input: $input){
                            id
                        }
                    }`,
                    variables: {
                        id: vItem.id,
                        input: {
                            estado: vEstado
                        }
                    }
                });
                if(response.data){
                    Swal.fire('Correcto', 'Se modificó correctamente', 'success');
                    this.dCrmCompromisos[this.dCrmCompromisos.indexOf(vItem)].estado = vEstado;
                } else {
                    Swal.fire('¡ ERROR !', 'No se modificó.', 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se modificó..', 'error');
            } finally {
            }
        },
        onFileSelected(event) {
            // this.dSelectedFile = event.target.files[0];
            this.dSelectedFile = this.$refs.fileInput.files[0];
            
            let reader = new FileReader();
            reader.onload = (e) => {
                this.dImagenMiniatura = e.target.result;
            }
            reader.readAsDataURL(this.dSelectedFile);
        },
        fuCalendarAdd(vItem){
            var vtext = "Compromiso "+vItem.id+" "+this.dPersona.tipo+" "+this.dPersona.Persona;
            var vdetails = vItem.crmcompromisotipo.nombre;
            var vfinicio = moment(vItem.vencimiento_at).format("YYYYMMDD HH:mm");
            var vffin = moment(vItem.vencimiento_at).add(10, 'minutes').format("YYYYMMDD HH:mm");
            var vdates = vfinicio+"/"+vffin;

            window.open("https://www.google.com/calendar/render?action=TEMPLATE&" +
                "text="+vtext+"&"+
                "details="+vdetails+"&" +
                "dates="+vdates+"&" +
                "ctz=America/Lima");
        }
    }
}
</script>
